import React from "react";
import { Home, GraduationCap, Receipt, Calendar, User } from "lucide-react";

export const ONGLETS = [
  { id: "aujourdhui", label: "Accueil", Icone: Home },
  { id: "cours", label: "Mes cours", Icone: GraduationCap },
  { id: "factures", label: "Factures", Icone: Receipt },
  { id: "planning", label: "Planning", Icone: Calendar },
  { id: "profil", label: "Profil", Icone: User },
];

/* La barre d'onglets, collée en bas : c'est elle qui fait la différence entre « un site
   qu'on scrolle » et « une application ». Tout est dans la zone du pouce, chaque cible
   fait au moins 48 px de haut, et la barre laisse la place à la barre gestuelle de
   l'iPhone (safe-area). */
export const BarreOnglets = ({ actif, onChange, solde, messages = 0 }) => (
  <nav className="fixed bottom-0 inset-x-0 z-40 border-t"
    style={{
      background: "rgba(255,255,255,0.88)",
      backdropFilter: "blur(16px)",
      WebkitBackdropFilter: "blur(16px)",
      borderColor: "var(--border)",
      /* Un peu d'air sous les libellés : sur un Android sans barre gestuelle, la
         safe-area vaut 0 et les mots se collaient au bord de l'écran. */
      paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 12px)",
      paddingTop: "2px",
    }}
    data-testid="espace-bottom-nav">
    <div className="max-w-lg mx-auto grid grid-cols-5">
      {ONGLETS.map(({ id, label, Icone }) => {
        const ouvert = actif === id;
        return (
          <button key={id} onClick={() => onChange(id)}
            className="relative flex flex-col items-center justify-center gap-1.5 py-3 min-h-[64px] transition-colors"
            /* Lisible à bout de bras : l'ancien 10 px gris clair se devinait plus qu'il ne
               se lisait. Icône 25 px, libellé 12,5 px, gris foncé pour les onglets au repos. */
            style={{ color: ouvert ? "var(--primary)" : "#475569" }}
            aria-current={ouvert ? "page" : undefined}
            data-testid={`espace-nav-${id}`}>
            <span className="relative">
              <Icone size={25} strokeWidth={ouvert ? 2.4 : 2} />
              {id === "factures" && solde > 0.5 && (
                <span className="absolute -top-1 -right-1.5 w-2.5 h-2.5 rounded-full"
                  style={{ background: "#B45309" }} data-testid="espace-nav-badge-factures" />
              )}
              {/* Un message de l'école pas encore lu (Profil → Messages de l'école). */}
              {id === "profil" && messages > 0 && (
                <span className="absolute -top-1 -right-1.5 w-2.5 h-2.5 rounded-full"
                  style={{ background: "var(--primary)" }} data-testid="espace-nav-badge-profil" />
              )}
            </span>
            <span className="text-[12px] font-semibold leading-none px-0.5" style={{ letterSpacing: "-0.01em" }}>{label}</span>
            {ouvert && (
              <span className="absolute top-0 w-8 h-[2.5px] rounded-full"
                style={{ background: "var(--primary)" }} />
            )}
          </button>
        );
      })}
    </div>
  </nav>
);
